export default __webpack_public_path__ + "static/HeroImage-7674d51cd4cc09df30b75c25d7740e4f.jpg";